// #region IMPORTS
import { createSlice } from '@reduxjs/toolkit';
// #endregion

// #region CONSTANTS
const initialState = {
  filters: {},
  region: null,
  vertical: null,
  series: [],
};
// #endregion

export const filtersSlice = createSlice({
  initialState,
  name: 'filters',
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    updateFilters(state, action) {
      state.filters = action.payload;
    },
    updateRegion(state, action) {
      state.region = action.payload;
    },
    updateVertical(state, action) {
      state.vertical = action.payload;
    },
    setSeries(state, action) {
      state.series = action.payload;
    },
  },
});

// #region ACTIONS
export const {
  updateFilters,
  updateRegion,
  updateVertical,
  setSeries,
} = filtersSlice.actions;
// #endregion

// #region SELECTORS
export const selectFilters = state => {
  return state.filters.filters;
};

export const selectRegion = state => {
  return state.filters.region;
};

export const selectVertical = state => {
  return state.filters.vertical;
};

export const selectSeries = state => {
  return state.filters.series;
};

// #endregion

export default filtersSlice.reducer;
